import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {HistoryClass} from '../../../Class/common/history/history-class';

@Injectable({
  providedIn: 'root'
})

export class HistoryService {

  baseUrl: string=environment.baseUrl + 'Common/';

  constructor(private http:HttpClient) { }
 
  ShowHistoryList(HistoryClass:HistoryClass):Observable<any>
  {
    return this.http.post<any>(this.baseUrl+'ShowHistoryList', HistoryClass);
  }
}
